import { logout } from 'keratin-authn'
import Swal from 'sweetalert2'

import config from '../../config/app-config'

/** Error code the API returns once every clinic of the staff has moved to Helix */
export const CLINIC_MIGRATED_ERROR = 'clinic_migrated'

let isNotifying = false

/**
 * Logs the staff out and tells them their clinic now lives in Helix.
 * Several requests can fail with `clinic_migrated` at once, so only the first
 * call shows the notice.
 */
export const notifyClinicMigrated = async () => {
  if (isNotifying) return
  isNotifying = true

  try {
    await logout()
  } catch {
    // The session may already be gone; the notice still needs to show
  }
  localStorage.removeItem('currentSite')

  const result = await Swal.fire({
    toast: false,
    width: 500,
    position: 'center',
    showConfirmButton: true,
    showCancelButton: true,
    confirmButtonText: 'Go to Helix',
    cancelButtonText: 'Close',
    allowOutsideClick: false,
    allowEscapeKey: false,
    confirmButtonColor: '#56AAEB',
    title: 'Your clinic has moved to Helix',
    text: 'Your clinic now uses Helix, so this account can no longer log in here. Please log in to Helix with your usual email to continue.',
    customClass: 'custom-sweetalert',
  })

  window.location.assign(
    result.isConfirmed ? config.helixLoginUrl : config.unAuthenticatedRootUrl,
  )
}
